import { useEffect } from 'react';
import { useNavigate } from 'react-router';

// Singleton to store navigate function
let navigateFunction: ((to: string, options?: any) => void) | null = null;

export const setNavigate = (navigate: (to: string, options?: any) => void) => {
	navigateFunction = navigate;
};

export const getNavigate = () => navigateFunction;

// Component to initialize navigation
export const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
	const navigate = useNavigate();

	useEffect(() => {
		setNavigate(navigate);
	}, [navigate]);

	return <>{children}</>;
};
